import { LoadManager } from '@/components'
import { Button } from '@/components/styles'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import documentNumberMask from '@/lib/masks/documentNumber'
import adoptions from '@/services/api/adoptions'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

export default function RevertAdoption({ title, adoptionId, onClose }) {
  usePageTitle({ title })
  const [reverting, setReverting] = useState(false)
  const history = useHistory()
  const { data, loading, error } = useAxiosRequest(adoptions.show, adoptionId)

  // eslint-disable-next-line consistent-return
  const close = useCallback(() => {
    if (onClose) return onClose()
    history.goBack()
  }, [onClose, history])

  const revert = useCallback(async () => {
    try {
      setReverting(true)
      await adoptions.revert(adoptionId)
      toast.success('Adoção revertida com sucesso')
      history.goBack()
      setReverting(false)
    } catch (e) {
      toast.error(e?.message)
    } finally {
      setReverting(false)
    }
  }, [adoptionId, history])

  return (
    <div className="modal active">
      <a
        type="button"
        className="modal-overlay"
        aria-label="Close"
        onClick={close}
      />
      <div className="modal-container">
        <div className="modal-header">
          <a
            type="button"
            className="btn btn-clear float-right"
            onClick={close}
          />
          <div className="modal-title h5">
            Você está certo que deseja reverter a adoção do pet
            <span className="text-primary"> {data?.animal?.name}</span>?
          </div>
        </div>
        <div className="modal-body">
          <LoadManager error={error} loading={loading}>
            <div>
              Ao reverter a adoção, a tutoria do pet voltará para{' '}
              <b>
                {data?.donor?.fullName} -{' '}
                {documentNumberMask(data?.donor?.documentNumber)
                  || 'Sem número de documento informado'}
              </b>
            </div>
            {data?.fair ? (
              <div className="mt-2 pt-2">
                O pet voltará a estar disponível para adoção na feira{' '}
                <b>{data.fair.title}</b> e uma nova solicitação de adoção poderá
                ser feita
              </div>
            ) : null}
          </LoadManager>
        </div>
        <div className="modal-footer">
          <Button
            className={`btn-sm btn-error ml-2 ${reverting ? 'loading' : ''}`}
            disabled={reverting}
            onClick={revert}
          >
            <i className="fas fa-undo" />
            &nbsp;Reverter adoção
          </Button>
        </div>
      </div>
    </div>
  )
}
RevertAdoption.propTypes = {
  title: PropTypes.string.isRequired,
  adoptionId: PropTypes.string.isRequired,
  onClose: PropTypes.func,
}

RevertAdoption.defaultProps = {
  onClose: null,
}
